import { useModuleStatuses } from '@features/properties';
import { useMemo } from 'react';
import { Item } from 'shared-types';
import { getModulesEveryPackageIncludes } from '../BasketDrawer.helpers';
import { ModuleType } from '../BasketListing.types';

export const useModulesToRecommend = ({
  modules,
  basketItems,
}: {
  modules: ModuleType[];
  basketItems?: Item[];
}) => {
  const {
    statuses: { isRoomsEnabled },
  } = useModuleStatuses();

  const recommendedModules = useMemo(() => {
    let updatedModules = modules;

    if (isRoomsEnabled && !updatedModules.includes('rooms')) {
      updatedModules = updatedModules.concat('rooms');
    }

    const includedInPackages = getModulesEveryPackageIncludes(basketItems ?? []);

    // We don't ever want to show these types of modules
    return updatedModules.filter(
      (module) =>
        module !== 'products' &&
        module !== 'vouchers' &&
        module !== 'events' &&
        !includedInPackages.includes(module)
    );
  }, [modules, isRoomsEnabled, basketItems]);

  return recommendedModules;
};
